import { useDisclosure } from "@heroui/react";
import { FileUploadModal } from "./fileUploadModal";

export function useFileUploadModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openFileUploadModal = ({
    onFileUploaded,
    accept = "image/*",
    multiple = false,
  }: {
    onFileUploaded: (urls: string[]) => void;
    accept?: string;
    multiple?: boolean;
  }) => {
    return (
      <FileUploadModal
        isOpen={isOpen}
        onClose={onClose}
        onFileUploaded={onFileUploaded}
        accept={accept}
        multiple={multiple}
      />
    );
  };

  return {
    FileUploadModal: openFileUploadModal,
    onOpen,
    onClose,
  };
}
